import type { ComponentMode, DiscountCode } from 'types';

interface State extends DiscountCode {
  mode: ComponentMode;
  defaultEnable: boolean;
  defaultCode: string;
}
const initialState: Partial<State> = {};

type Action =
  | {
      type: 'UPDATE_DISCOUNT_CODE_TYPE';
      payload: Pick<typeof initialState, 'type'>;
    }
  | {
      type: 'UPDATE_DISCOUNT_CODE_AMOUNT';
      payload: Pick<typeof initialState, 'amount'>;
    }
  | {
      type: 'UPDATE_DISCOUNT_CODE_DURATION';
      payload: Pick<typeof initialState, 'duration'>;
    }
  | undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
